module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER I")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A Tramp over Europe—On the Holsatia—Hamburg—Frankfort-on-the-Main—How it Won its Name—A Lesson in Political Economy—Neatness in Dress—Rhine Legends—“The Knave of Bergen” The Famous Ball—The Strange Knight—Dancing with the Queen—Removal of the Masks—The Disclosure—Wrath of the Emperor—The Ending")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER II")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At Heidelberg—Great Stir at a Hotel—The Portier—Arrival of the Empress—The Schloss Hotel—Location of Heidelberg—The River Neckar—New Feature in a Hotel—Heidelberg Castle—View from the Hotel—A Tramp in the Woods—Meeting a Raven—Can Ravens Talk?—Laughed at an Vanquished—Language of Animals—Jim Baker—Blue-Jays")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER III")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Baker’s Blue-Jay Yarn—Jay Language—The Cabin—“Hello, I reckon I’ve struck something—“A Knot Hole—Attempt to fill it—A Ton of Acorns—Friend Called In—A Great Mystery—More Jays called A Blue Flush—A Discovery—A Rich Joke—One that Couldn’t See It")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER IV")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Student Life—The Five Corps—The Beet King—A Free Life—Attending Lectures—An Immense Audience—Industrious Students—Politeness of the Students—Intercourse with the Professors Scenes at the Castle Garden—Abundance of Dogs—Symbol of Blighted Love—How the Ladies Advertise")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER V")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Students’ Dueling Ground—The Dueling Room—The Sword Grinder—Frequency of the Duels—The Duelists—Protection against Injury—The Surgeon—Arrangements for the Duels—The First Duel—The First Wound—A Drawn Battle—The Second Duel—Cutting and Slashing—Interference of the Surgeon")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER VI")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Third Duel—A Sickening Spectacle—Dinner between Fights—The Last Duel—Fighting in Earnest—Faces and Heads Mutilated—Great Nerve of the Duelists—Fatal Results not Infrequent—The World’s View of these Fights")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER VII")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Corps—laws and Usages—Volunteering to Fight—Coolness of the Wounded—Wounds Honorable—Newly bandaged Students around Heidelberg—Scarred Faces Abundant—A Badge of Honor—Prince Bismark as a Duelist—Statistics—Constant Sword Practice—Color of the Corps—Corps Etiquette")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf766384","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrampAbroad3.vue
// module id = 69
// module chunks = 0